import { gql } from '@apollo/client/core'

export const WORKFLOW_RUN = gql`
  query workflowRun($runId: String!) {
    workflowRun(runId: $runId) {
      runId
      subjectId
      kind
      state
      errorMessage
    }
  }
`
